export const AD_STORE_ATTEMPT = "AD_STORE_ATTEMPT";
export const AD_STORE_SUCCESS = "AD_STORE_SUCCESS";
export const AD_STORE_FAILED = "AD_STORE_FAILED";
///
export const AD_STORE_CLEAR = "AD_STORE_CLEAR";

export const AD_STORE_MORE_ATTEMPT = "AD_STORE_MORE_ATTEMPT";
export const AD_STORE_MORE_SUCCESS = "AD_STORE_MORE_SUCCESS";
export const AD_STORE_MORE_FAILED = "AD_STORE_MORE_FAILED";
export const LOGOUT = "LOGOUT";